// extracted by mini-css-extract-plugin
export default {"email":"AccountPopover_email__byRAL","popover":"AccountPopover_popover__Q7M3N"};